import React from 'react';
import Modal from '@ls/react-modal';
import Button from '@ls/react-button';
import styled from 'styled-components';

const Root = styled.div`
  padding: 10px;
  min-width: 300px;
  min-height: 200px;
  max-height: 90vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  white-space: pre-wrap;
`;

const Title = styled.div`
  font-size: 1.25rem;
  line-height: 2rem;
  font-weight: 500;
`;

const Message = styled.div`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  letter-spacing: 0.04em;
  flex: 1 1 100px;
  max-width: 50vw;
  word-wrap: break-word;
`;

const ButtonSection = styled.div`
  align-self: center;
`;

const str = JSON.stringify;

const ErrorModal = ({error, resetErrorBoundary}) => {
  const [title, message] = React.useMemo(() => {
    let _title, _message;
    if (!error) {
      _title = null;
      _message = null;
    }
    else if (error.isAxiosError) { //http error
      _title = str(error.message);
      if (error?.response?.data?.message) {
        _message = str(error.response.data.message);
      }
      else if (error?.response?.data) {
        _message = str(error.response.data);
      }
      _message = <pre>{_message}</pre>;
    }
    else {
      /*Title*/
      _title = error.title ?? 'Error';

      /*Message*/
      if (typeof error === 'string') {
        _message = error;
      } else if (error.message) {
        _message = str(error.message);
      } else if (error.msg) {
        _message = str(error.msg);
      } else {
        _message = str(error);
      }
    }
    return [_title, _message];
  }, [error]);

  return (
    <Modal active={!!error}>
      <Root>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <ButtonSection>
          <Button
            label="OK"
            onButtonClick={resetErrorBoundary}
            variation={3}
          />
        </ButtonSection>
      </Root>
    </Modal>
  );
}

export default ErrorModal;